/**
 * Logic behind showing and hidding specific auth form
 * Includes login, register and password reset
 */
export default class SliderInstance {
    constructor() {
        /**
         * DOM elements and states
         * @type {{passwordResetFormTrigger: string, loginForm: string, passwordResetForm: string, registerForm: string, registerFormTrigger: string, formWrapper: string, states: {active: string}}}
         */
        this.DOM = {
            formWrapper: ".js-auth-form",
            loginForm: ".js-auth-form-login",
            loginLastNameInput: "#loginLastName",
            registerForm: ".js-auth-form-register",
            registerFormTrigger: ".js-auth-form-register-trigger",
            registerLastNameInput: "#registerLastName",
            passwordResetForm: ".js-auth-form-password-reset",
            passwordResetFormTrigger: ".js-auth-form-password-reset-trigger",
            passwordResetLastNameInput: "#passwordResetLastName",
            states: {
                active: "is-active",
            },
        };

        /**
         * fetch form wrapper DOM el
         * @type {Element}
         */
        this.formWrapper = document.querySelector(this.DOM.formWrapper);

        /**
         * fetch login form DOM el
         * @type {Element}
         */
        this.loginForm = document.querySelector(this.DOM.loginForm);

        /**
         * fetch login last name DOM el
         * @type {Element}
         */
        this.loginLastNameInput = document.querySelector(this.DOM.loginLastNameInput);

        /**
         * fetch register form DOM el
         * @type {Element}
         */
        this.registerForm = document.querySelector(this.DOM.registerForm);

        /**
         * fetch register form trigger DOM el
         * @type {Element}
         */
        this.registerFormTrigger = document.querySelector(
            this.DOM.registerFormTrigger,
        );

        /**
         * fetch register last name DOM el
         * @type {Element}
         */
        this.registerLastNameInput = document.querySelector(this.DOM.registerLastNameInput);

        /**
         * fetch password reset form DOM el
         * @type {Element}
         */
        this.passwordResetForm = document.querySelector(
            this.DOM.passwordResetForm,
        );

        /**
         * fetch password reset form trigger DOM el
         * @type {Element}
         */
        this.passwordResetFormTrigger = document.querySelector(
            this.DOM.passwordResetFormTrigger,
        );

        /**
         * fetch password reset last name DOM el
         * @type {Element}
         */
        this.passwordResetLastNameInput = document.querySelector(this.DOM.passwordResetLastNameInput);
    }

    /**
     * Init
     */
    init() {
        if (
            this.formWrapper === null ||
            this.loginForm === null ||
            this.loginLastNameInput === null || 
            this.registerForm === null ||
            this.registerFormTrigger === null ||
            this.registerLastNameInput === null || 
            this.passwordResetForm === null ||
            this.passwordResetFormTrigger === null || 
            this.passwordResetLastNameInput === null
        ) {
            return;
        }
        this.formControl();
    }

    /**
     * Add listeners
     */
    formControl() {
        this.registerFormTrigger.addEventListener("click", (event) => {
            event.preventDefault();
            this.showRegisterForm();
        });
        this.passwordResetFormTrigger.addEventListener("click", (event) => {
            event.preventDefault();
            this.showPasswordResetForm();
        });
        this.loginLastNameInput.addEventListener("input", (event) => {
            event.preventDefault();
            this.makeLoginSubmitButtonEnabled(this.loginLastNameInput.value);
        });
        this.registerLastNameInput.addEventListener("input", (event) => {
            event.preventDefault();
            this.makeRegisterSubmitButtonEnabled(this.registerLastNameInput.value);
        });
        this.passwordResetLastNameInput.addEventListener("input", (event) => {
            event.preventDefault();
            this.makePasswordResetSubmitButtonEnabled(this.passwordResetLastNameInput.value);
        });
    }

    /**
     * Show login form and hide previously active
     */
    showLoginForm() {
        this.hidePreviouslyActive();
        this.makeFormActive(this.loginForm);
    }

    /**
     * Show register form and hide previously active
     */
    showRegisterForm() {
        this.hidePreviouslyActive();
        this.makeFormActive(this.registerForm);
    }

    /**
     * Show register form and hide previously active
     */
    showPasswordResetForm() {
        this.hidePreviouslyActive();
        this.makeFormActive(this.passwordResetForm);
    }

    /**
     * Hide previously active
     */
    hidePreviouslyActive() {
        let previouslyActive = this.formWrapper.querySelector(
            `.${this.DOM.states.active}`,
        );
        previouslyActive.classList.remove(this.DOM.states.active);
        previouslyActive.style.display = "none";
    }

    /**
     * Make form active and show it
     * @param element
     */
    makeFormActive(element) {
        element.classList.add(this.DOM.states.active);
        element.style.display = "block";
    }

    /**
     * Enable or disable submit button based on lastname field
     */
    makeLoginSubmitButtonEnabled(lastNameValue) {
        let loginSubmitButton = this.loginForm.querySelector(".loginSubmitButton");

        if (loginSubmitButton) {
            if (lastNameValue.trim() !== "") {
                // Disable the submit button when the last name field has a value
                loginSubmitButton.disabled = true;
                loginSubmitButton.classList.add("disabled");
            } else {
                // Enable the submit button when the last name field is empty
                loginSubmitButton.disabled = false;
                loginSubmitButton.classList.remove("disabled");
            }
        }
    }

    /**
     * Enable or disable submit button based on lastname field
     */
    makeRegisterSubmitButtonEnabled(lastNameValue) {
        let registerSubmitButton = this.registerForm.querySelector(".registerSubmitButton");

        if (registerSubmitButton) {
            if (lastNameValue.trim() !== "") {
                // Disable the submit button when the last name field has a value
                registerSubmitButton.disabled = true;
                registerSubmitButton.classList.add("disabled");
            } else {
                // Enable the submit button when the last name field is empty
                registerSubmitButton.disabled = false;
                registerSubmitButton.classList.remove("disabled");
            }
        }
    }

    /**
     * Enable or disable submit button based on lastname field
     */
    makePasswordResetSubmitButtonEnabled(lastNameValue) {
        let passwordResetSubmitButton = this.passwordResetForm.querySelector(".passwordResetSubmitButton");

        if (passwordResetSubmitButton) {
            if (lastNameValue.trim() !== "") {
                // Disable the submit button when the last name field has a value
                passwordResetSubmitButton.disabled = true;
                passwordResetSubmitButton.classList.add("disabled");
            } else {
                // Enable the submit button when the last name field is empty
                passwordResetSubmitButton.disabled = false;
                passwordResetSubmitButton.classList.remove("disabled");
            }
        }
    }
}
